<template>
  <div
    class="dataBaseDetail"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">{{ eng_PlantingName }}</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCategory">{{ eng_typeName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.englishName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <el-popover placement="left" width="250" trigger="hover">
      <div class="tel">Contact Number：{{templeContact}}</div>
      <div class="tel">Email：{{templeEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>Contact art studio</div>
          </div>
      </div>
    </el-popover>
  </div>
  <div class="dataBaseDetail" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">{{ za_PlantingName }}</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCategory">{{ za_typeName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.zangName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
      <div class="tel">སྦྲགས་ཡིག：{{templeEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/exhibitionsale/phone.png" alt="" />
          <div>འབྲེལ་གཏུག</div>
        </div>
      </div>
    </el-popover>
  </div>
  <div class="dataBaseDetail" v-else>
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">{{ PlantingName }}</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCategory">{{ typeName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.chineseName }}</span>
        </div>
      </div>
    </div>
    <Common-detail></Common-detail>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">联系电话：{{templeContact}}</div>
      <div class="tel">邮件：{{templeEmail}}</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/exhibitionsale/phone.png" alt="" />
          <div>联系画院</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import CommonDetail from "../../components/commonDetail.vue";
import { productGet } from "../../api/management.js";
import PicTop from "../../components/picsTop.vue";
export default {
  components: {
    CommonDetail,
    PicTop,
  },
  data() {
    return {
      url: process.env.VUE_APP_WEB_URL,
      id: this.$route.query.id,
      item: {},
      typeName: "", //分类名
      za_typeName: "", //分类名
      eng_typeName: "", //分类名
      eng_PlantingName:'Regong Works Exhibition',
      za_PlantingName:'རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།',
      PlantingName:'热贡作品展',
      category: "", //分类ID
      language: this.$store.state.language,
      templeContact:'',
      templeEmail:''
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  created() {
    this.getProductGet();
  },
  mounted() {
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  methods: {
    async getProductGet() {
      const res = await productGet(this.id);
      this.item = res.data;
      if(res.data.templeContact) {
        this.templeContact = res.data.templeContact;
      } else {
        this.templeContact = '18997193666';
      }
      if(res.data.templeEmail) {
        this.templeEmail = res.data.templeEmail;
      } else {
        this.templeEmail = 'regong_art_db@163.com';
      }
      this.category = res.data.category;
      let category = res.data.category;
      if (category == 1) {
        this.typeName = "唐卡";
        this.za_typeName = " ཐང་ག ";
        this.eng_typeName = "Thangka";
      } else if (category == 2) {
        this.typeName = "泥塑";
        this.za_typeName = "འཇིམ་བཟོ།";
        this.eng_typeName = "Clay sculpture";
      } else if (category == 3) {
        this.typeName = "壁画";
        this.za_typeName = "ལྡེབས་རིས། ";
        this.eng_typeName = "Mural";
      } else if (category == 4) {
        this.typeName = "堆绣";
        this.za_typeName = "དྲས་དྲུབ།";
        this.eng_typeName = "Pile embroidery";
      } else if (category == 5) {
        this.typeName = "彩绘";
        this.za_typeName = " ཚོན་རིས། ";
        this.eng_typeName = "Paintings";
      } else if (category == 6) {
        this.typeName = "其他类";
        this.eng_typeName = "Other";
        this.za_typeName = "རིགས་གཞན་དག་";
      }
    },
    goCategory() {
      this.$router.back()
    },
    // 判断手机端还是PC端
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.width = 320;
        this.height = 380;
      } else {
        this.width = 460;
        this.height = 610;
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss">
.dataBaseDetail {
  position: relative;
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .dataBaseDetailTop {
    border-bottom: 1px solid #f4f5f6;
    position: relative;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
  .contact {
    z-index: 999;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .message {
      text-align: center;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      margin-bottom: 20px;
      box-shadow: 0 0 10px #99131a;
      font-size: 12px;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
}
@media (max-width: 768px) {
  .dataBaseDetail {
    background-size: 15%;
    position: relative;
    margin: 0;
    padding-bottom: 1rem;
    .dataBaseDetailTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
    }
    .contact {
      right: 1%;
      z-index: 1000;
      bottom: 35%;
      .message {
        padding: 0.2rem !important;
        width: 1.7rem;
        height: 1.7rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem !important;
        }
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: -3.5%;
      width: 1.25rem;
    }
  }
}
</style>
